var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-content"},[_c('div',{ref:"myChart",staticClass:"chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }